import SellCollectionModal from './SellCollectionModal.container'

export default SellCollectionModal
